import { GeneralCatalogItem } from 'data-layer-cr/dist/models';

/** Filters a GeneralCatalogItem from renderConditions
 *
 * @param arrayToFilter - Endpoint's all items in array.
 * @param arrayToMatch -
 * @returns
 */
const filterGeneralCatalog = (
  arrayToFilter: GeneralCatalogItem[],
  arrayToMatch: string[] | undefined,
): GeneralCatalogItem[] => {
  if (arrayToMatch) {
    return arrayToFilter.filter((item) => arrayToMatch.includes(item.code));
  }
  return arrayToFilter;
};

export default filterGeneralCatalog;
